export enum MUTATION_KEYS {
  CREATE_TOOL = 'CREATE_TOOL',
  UPDATE_TOOL = 'UPDATE_TOOL',
  DELETE_TOOL = 'DELETE_TOOL',
}

export default MUTATION_KEYS
